import { createContext } from "react";
export const AllContent= createContext();